<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
  @import "@/assets/scss/vuexy/pages/Config.scss";

  .custom-list{
    min-width: 215px;
  }
</style>
<template lang="html">
  <div>
    <vx-card class="m-2">
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showConfig = !showConfig"  type="flat" color="grey" class="float-right">
          <span v-show="!showConfig"  class="font-bold">{{$t('Labels.ShowConfigAlerts')}}</span>
          <span v-show="showConfig"  class="font-bold">{{$t('Labels.HideConfigAlerts')}}</span>
        </vs-button>
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
        <vs-button  @click="showControls = !showControls"  type="flat" color="grey" class="float-right">
          <span v-show="!showControls"  class="font-bold">{{$t('Labels.ShowControls')}}</span>
          <span v-show="showControls"  class="font-bold">{{$t('Labels.HideControls')}}</span>
        </vs-button>
      </div>
    </div>
    
    <div class="vx-row" v-show="showConfig">
      <div class="text-danger text-center w-full">{{$t('Messages.AlertsAll')}}</div>
      <div class="container-alerts w-full">
        <minMaxItem 
          :title="$t('Labels.Current')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="electric_current_min" 
          paramMax="electric_current_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="10"
          ></minMaxItem>
        
        <minMaxItem 
          :title="$t('Labels.Voltage')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          :paramMin="`electric_voltage_min`" 
          :paramMax="`electric_voltage_max`" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="active_power_min" 
          paramMax="active_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="reactive_power_min" 
          paramMax="reactive_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ApparentPower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid" 
          paramMin="apparent_power_min" 
          paramMax="apparent_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.PowerFactor')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid" 
          paramMin="factor_power_min" 
          paramMax="factor_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1"
          :step="0.1"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="active_energy_min" 
          paramMax="active_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="reactive_energy_min" 
          paramMax="reactive_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.Frequency')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="frequency_min" 
          paramMax="frequency_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="100"
          ></minMaxItem>
      </div>
    </div>
    <div  class="vx-row " v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <vs-checkbox v-model="filterLastSeen" class="font-bold mb-1">{{$t('Labels.LastSeen')}}</vs-checkbox>
      </div>
    </div>
    <div class="vx-row pt-2 pb-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.From')}}</label>
        <datepicker :value="filters.beginDate" format="dd-MM-yyyy" :disabled-dates="disabledDates" :disabled="!filterLastSeen" @selected="updateStartDate"></datepicker>  
        <div v-if="!datesValid" class="text-xs text-danger">{{$t('Messages.DatesRange')}}</div>
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.To')}}</label>
        <datepicker :value="filters.endDate" format="dd-MM-yyyy" :disabled-dates="disabledDates" :disabled="!filterLastSeen" @selected="updateEndDate"></datepicker>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="getResponse()" :disabled="!datesValid" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-3" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.Serie')}}</label>
        <vs-input class="w-full" v-model="filters.serie" />
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0 sm:pt-3">
        <ul>
          <li>
            <vs-radio v-model="filters.status" vs-name="radios1" vs-value="1" color="success">{{$t('Labels.On')}}</vs-radio>
          </li>
          <li>
          <vs-radio v-model="filters.status" vs-name="radios1" vs-value="0" color="danger">{{$t('Labels.Off')}}</vs-radio>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0 sm:pt-3">
        <vs-dropdown class="bg-white py-3 w-full border-2 border-solid border-grey rounded-lg " vs-custom-content vs-trigger-click>
          <a class="a-icon" href.prevent>
            {{$t("Labels.Circuit")}}
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu class="custom-list">
            <vs-checkbox class="my-1" v-model="circuitsAll">{{$t('Labels.All')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="circuitsSelected" :vs-value="item.uuid" :key="item.objectID" v-for="item in circuits">{{item.name}}</vs-checkbox>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div class="vx-row mb-3" v-show="showFilters">
      <div class="vx-col w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.Current')}}</label>
        <vs-slider v-model="filters.current" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.Voltage')}}</label>
        <vs-slider v-model="filters.voltage" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.ActivePower')}}</label>
        <vs-slider v-model="filters.power" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.ActiveEnergy')}}</label>
        <vs-slider v-model="filters.energy" text-fixed="%"  :min="0" :max="100"/>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full text-center sm:hidden">
        <vs-button @click="getResponse()" :disabled="!datesValid" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row" v-show="showControls">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0 text-center">
        <iconLight width="80" height="80" iconColor="#ffbd59" :level="slideLight" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0 pt-8 text-center">
        <div class="inline-block align-middle font-bold" :class="{'text-grey': controlLight }" >Off</div>
        <div class="inline-block align-middle mx-2">
          <vs-switch v-model="controlLight" color="success"/>
        </div>
        <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlLight }">On</div>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0  pt-6 text-center">
        <vs-slider v-model="slideLight" :min="0" :max="100" text-fixed="%"/>
      </div>
      <div class="vx-col  w-full my-2 sm:w-auto sm:my-0 text-center">
        <vs-button @click="requestPassword()" color="primary" class="mr-2 mt-6">{{$t('Labels.Apply')}}</vs-button>
      </div>
    </div>
    </vx-card>
    <vx-card class="m-2">
    <div class="vx-row my-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder !== 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>  
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0"> 
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"/>
      </div>
      <vs-dropdown class="vx-col w-full sm:w-auto sm:my-0" vs-custom-content vs-trigger-click>
        <a class="a-icon" href.prevent>
          {{$t("Labels.ConfigView")}}
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-checkbox class="my-1" v-model="checkFields.status">{{$t('Labels.Status')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.name">{{$t('Labels.Name')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.serie">{{$t('Labels.Serie')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.circuit">{{$t('Labels.Circuit')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.lastSeen">{{$t('Labels.LastSeen')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.activeEnergy">{{$t('Labels.ActiveEnergy')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.activePower">{{$t('Labels.ActivePower')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.reactivePower">{{$t('Labels.ReactivePower')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.electricCurrent">{{$t('Labels.Current')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.electricVoltage">{{$t('Labels.Voltage')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.factorPower">{{$t('Labels.PowerFactor')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.frequency">{{$t('Labels.Frequency')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.inclination">{{$t('Labels.Inclination')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.alertState">{{$t('Labels.Status')+ ' ' +$t('Labels.Alert')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.alertInclination">{{$t('Labels.Inclination') + ' ' +$t('Labels.Alert')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.alertCurrent">{{$t('Labels.Current')+ ' ' +$t('Labels.Alert')}}</vs-checkbox>
          <vs-checkbox class="my-1" v-model="checkFields.alertDimming">{{$t('Labels.Dimming')+ ' ' +$t('Labels.Alert')}}</vs-checkbox>
          <div class="text-center">
            <vs-button @click="saveConfig()" class="bg-primary" type="filled" size="small">{{$t("Labels.Save")}}</vs-button>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <vs-table  v-if="response" :data="response" @selected="goToDetail">
      <template slot="thead">
        <vs-th v-if="checkFields.status">
          {{$t('Labels.Status')}}
        </vs-th>
        <vs-th v-if="checkFields.name">
          {{$t('Labels.Name')}}
        </vs-th>
        <vs-th v-if="checkFields.serie">
          {{$t('Labels.Serie')}}
        </vs-th>
        <vs-th v-if="checkFields.circuit">
          {{$t('Labels.Circuit')}}
        </vs-th>
        <vs-th v-if="checkFields.lastSeen">
          {{$t('Labels.LastSeen')}}
        </vs-th>
        <vs-th v-if="checkFields.activeEnergy">
          {{$t('Labels.ActiveEnergy')}}
        </vs-th>
        <vs-th v-if="checkFields.activePower">
          {{$t('Labels.ActivePower')}}
        </vs-th>
        <vs-th v-if="checkFields.reactivePower">
          {{$t('Labels.ReactivePower')}}
        </vs-th>
        <vs-th v-if="checkFields.electricCurrent">
          {{$t('Labels.Current')}}
        </vs-th>
        <vs-th v-if="checkFields.electricVoltage">
          {{$t('Labels.Voltage')}}
        </vs-th>
        <vs-th v-if="checkFields.factorPower">
          {{$t('Labels.PowerFactor')}}
        </vs-th>
        <vs-th v-if="checkFields.frequency">
          {{$t('Labels.Frequency')}}
        </vs-th>
        <vs-th v-if="checkFields.inclination">
          {{$t('Labels.Inclination')}}
        </vs-th>
        <vs-th v-if="checkFields.alertInclination">
          {{$t('Labels.Alert')}}
        </vs-th>
        <vs-th v-if="checkFields.alertState">
          {{$t('Labels.Alert')}}
        </vs-th>
        <vs-th v-if="checkFields.alertCurrent">
          {{$t('Labels.Alert')}}
        </vs-th>
        <vs-th v-if="checkFields.alertDimming">
          {{$t('Labels.Alert')}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="item" :key="index" @click="goToDetail(item.id)" v-for="(item, index) in data" :class="{'inactive': !item.updatedAt }">
          <vs-td v-if="checkFields.status">
            <div class="text-left my-2">
              <iconLight class="align-middle" width="50" height="50" iconColor="#ffbd59" :level="parseInt(item.dimming) * 100 / 255" />
              <span class="font-bold align-middle">{{Math.ceil(parseInt(item.dimming || 0) * 100 / 255)}} %</span>
            </div>
          </vs-td>
          <vs-td :data="item.name" v-if="checkFields.name">
            {{item.name}}
          </vs-td>
          <vs-td :data="item.serie" v-if="checkFields.serie">
            {{item.serie}}
          </vs-td>
          <vs-td :data="item.luminaires_circuit" v-if="checkFields.circuit">
            <div v-if="item.luminaires_circuit" class="w-5 h-5 inline-block rounded-sm" :style="{ 'background-color': item.luminaires_circuit.color }"></div>
            {{item.luminaires_circuit !== null ? item.luminaires_circuit.name : 'N/A'}}
          </vs-td>
          <vs-td :data="item.updatedAt" v-if="checkFields.lastSeen">
            <span>{{item.updatedAt.length > 0 ? relativeTimeConvert(item.updatedAt) : $t('Labels.Inactive')}}</span>
          </vs-td>
          <vs-td :data="item.active_energy" v-if="checkFields.activeEnergy">
            {{parseFloat(item.active_energy).toFixed(2)}} <span class="unit">Wh</span>
          </vs-td>
          <vs-td :data="item.active_power" v-if="checkFields.activePower">
            {{parseFloat(item.active_power).toFixed(2)}} <span class="unit">W</span>
          </vs-td>
          <vs-td :data="item.reactive_power" v-if="checkFields.reactivePower">
            {{parseFloat(item.reactive_power).toFixed(2)}} <span class="unit">VAR</span>
          </vs-td>
          <vs-td :data="item.electric_current" v-if="checkFields.electricCurrent">
            {{parseFloat(item.electric_current).toFixed(2)}} <span class="unit">A</span>
          </vs-td>
          <vs-td :data="item.electric_voltage" v-if="checkFields.electricVoltage">
            {{parseFloat(item.electric_voltage).toFixed(2)}} <span class="unit">V</span>
          </vs-td>
          <vs-td :data="item.factor_power" v-if="checkFields.factorPower">
            {{parseFloat(item.factor_power).toFixed(2)}}
          </vs-td>
          <vs-td :data="item.frequency" v-if="checkFields.frequency">
            {{parseFloat(item.frequency).toFixed(2)}}  <span class="unit">Hz</span>
          </vs-td>
          <vs-td :data="item.inclination" v-if="checkFields.inclination">
            {{parseFloat(item.inclination).toFixed(2)}}  <span class="unit">°</span>
          </vs-td>
          <vs-td v-if="checkFields.alertInclination">
            <statusItem 
              :status="parseInt(item.inclination) < 45?'success':'danger'"
              :description="parseInt(item.inclination) < 45?$t('Labels.Inclination'): $t('Labels.FailureInclination')"
            />
          </vs-td>
          <vs-td v-if="checkFields.alertState">
            <statusItem 
              :status="parseInt(item.state_failure) === 0 ?'success':'danger'"
              :description="parseInt(item.state_failure) === 0 ?$t('Labels.Relay') :$t('Labels.FailureRelay')"
            />
          </vs-td>
          <vs-td v-if="checkFields.alertCurrent">
            <statusItem 
              :status="parseInt(item.current_failure) === 0 ?'success':'danger'"
              :description="parseInt(item.current_failure) === 0 ?$t('Labels.Current') :$t('Labels.FailureCurrent')"
            />
          </vs-td>
          <vs-td v-if="checkFields.alertDimming">
            <statusItem 
              :status="parseInt(item.dimming_failure) === 0 ?'success':'danger'"
              :description="parseInt(item.dimming_failure) === 0 ?$t('Labels.Dimming') :$t('Labels.FailureDimming')"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination class="mt-5" v-if="response" :max="3" :total="totalPages" v-model="currentx"></vs-pagination>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {formatDate, empty, getExactNumer} from '@/helpers.js'
import listItem from '@/components/listItem/listItem.vue'
import statusItem from '@/components/statusItem/statusItem.vue'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'
import iconLight from '@/components/icons/iconLight'
import {globalPassActions} from '@/globalPass'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'

export default {
  components: {
    listItem,
    statusItem,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconFilter,
    iconLight,
    minMaxItem
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'updatedAt',
        byOrder: 'ASC',
        serie:null,
        beginDate: new Date(),
        endDate: new Date(),
        status: this.$route.query.status !== undefined ? this.$route.query.status : null,
        current: [0, 100],
        voltage: [0, 100],
        power: [0, 100],
        energy: [0, 100]
      },
      endDate: new Date(),
      filterLastCharge: false,
      filterLastSeen: false,
      filterBeginEndLastSeen: true,
      columnOrders:[
        {label: this.$t('Labels.Serie'), value: 'serie'},
        {label: this.$t('Labels.Circuit'), value: 'luminaires_circuits.name'},
        {label: this.$t('Labels.LastSeen'), value: 'updatedAt'}
      ],
      byColumn: 'updatedAt',
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false,
      controlLight: false,
      slideLight: 0,
      showControls: false,
      showConfig: false,
      checkFields:{
        status: false,
        name: false,
        serie: false,
        circuit: false,
        lastSeen: false, 
        alertInclination: false,
        activeEnergy: false,
        activePower: false,
        alertCurrent: false,
        alertDimming: false,
        electricCurrent: false,
        electricVoltage: false,
        factorPower: false,
        frequency: false,
        inclination: false,
        reactivePower: false, 
        alertState: false
      },
      circuits:[],
      circuitsAll: true,
      circuitsSelected: [],
      disabledDates: {
        from: new Date()
      },
      ban: false,
      uuid: null,
      maxActiveEnergy: 0,
      maxActivePower: 0,
      maxCurrent: 0,
      maxVoltage: 0
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      filter.serie = this.filters.serie
      filter.name = this.filters.name
      filter.state = this.filters.status
      
      if (this.maxCurrent > 0) {
        filter.begin_electric = getExactNumer(this.filters.current[0], this.maxCurrent)
        filter.end_electric = getExactNumer(this.filters.current[1], this.maxCurrent)
      }
      if (this.maxVoltage > 0) {
        filter.begin_voltage = getExactNumer(this.filters.voltage[0], this.maxVoltage)
        filter.end_voltage = getExactNumer(this.filters.voltage[1], this.maxVoltage)
      }  
      if (this.maxActivePower > 0) {
        filter.begin_power = getExactNumer(this.filters.power[0], this.maxActivePower)
        filter.end_power = getExactNumer(this.filters.power[1], this.maxActivePower)
      }
      if (this.maxActiveEnergy > 0) {
        filter.begin_energy = getExactNumer(this.filters.energy[0], this.maxActiveEnergy)
        filter.end_energy = getExactNumer(this.filters.energy[1], this.maxActiveEnergy)
      }
      if (!this.circuitsAll) filter.luminary_circuit_uuid = this.circuitsSelected

      if (this.filterLastSeen) {
        filter.begin_date = formatDate(this.filters.beginDate)
        filter.end_date = formatDate(this.filters.endDate)
      }
        
      
      const params = {
        url: 'luminaires_devices',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.setPages(response.data.data.count)
        this.response = response.data.data.rows
        this.maxActiveEnergy = response.data.data.max_active_energy
        this.maxActivePower = response.data.data.max_active_power
        this.maxCurrent = response.data.data.max_electric_current
        this.maxVoltage = response.data.data.max_electric_voltage
        const uuids = []
        this.response.forEach(element => {
          uuids.push(element.uuid)
        })
        this.uuid = uuids.join(',')
        if (this.response.length > 0) {
          const fieldsView = response.data.data.see_data.split(',')
          fieldsView.forEach(element => {
            this.checkFields[element] = true
          })
        }
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
        this.filterBeginEndLastSeen = false
      })
      
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.circuit = null
      this.filters.recharge_at = new Date()
      this.filters.current = [0, 100]
      this.filters.voltage = [0, 100]
      this.filters.power = [0, 100]
      this.filters.energy = [0, 100]
      this.filterLastSeen = false
      this.filters.status = null
      this.circuitsAll = true
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (tr) {
      if (!empty(tr.uuid)) window.location.href = `/luminarias/${tr.uuid}`
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    requestPassword () {
      this.ban = true
      globalPassActions.show()
    },
    async update () {
      this.selected = []
      this.response.forEach(element => {
        this.selected.push(element.uuid)
      })

      const params = {
        url: 'luminaires_devices/update_masive',
        method: 'PUT',
        params: {
          type: 'G',
          uuids: this.selected.join(','),
          dimming: Math.ceil((this.slideLight * 255) / 100)
        }
      }
      await request(params).then(() => {
        this.getResponse()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    updateStartDate (date) {
      this.filters.beginDate = date
    },
    updateEndDate (date) {
      this.filters.endDate = date
    },
    async getCircuits () {
      const params = {
        url: 'luminaires_circuits/list',
        method: 'GET'
      }
      await request(params).then(response => {
        this.circuits = response.data.data
        this.circuitsAll = true
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async saveConfig () {
      let see_data = ''
      for (const p in this.checkFields) {
        if (this.checkFields[p] === true) see_data += `${p  },`
      }
      const params = {
        url: 'luminaires_devices/configuration',
        method: 'PUT',
        params: {
          see_data
        }
      }
      await request(params).then(() => {
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
    this.getCircuits()
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    },
    datesValid () {
      const begin = new Date(this.filters.beginDate)
      const end = new Date(this.filters.endDate)
      return ((begin <= end && this.filterLastSeen) || this.filterLastSeen === false)  
    }
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    },
    controlLight (newVal) {
      if (!newVal) this.slideLight = 0
      else if (this.slideLight === 0) this.slideLight = 100 
    },
    slideLight (newVal) {
      if (newVal > 0 && this.controlLight === false) this.controlLight = true
      else if (newVal === 0 && this.controlLight === true) this.controlLight = false
    },
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible === false && this.ban === true) {
        this.update()
        this.ban = false
      }
    },
    circuitsAll (val, old) {
      if (val === true && old === false) {
        this.circuitsSelected = []
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      } 
    },
    circuitsSelected (val) {
      if (val.length < this.circuits.length) this.circuitsAll = false
    },
    showControls (val) {
      if (val) {
        this.showFilters = false
        this.showConfig = false
      }
        
    },
    showFilters (val) {
      if (val) {
        this.showControls = false
        this.showConfig = false
      }
    },
    showConfig (val) {
      if (val) {
        this.showControls = false
        this.showFilters = false
      }
    }
  }
}
</script>